<template>
  <div>
    <div
      class="br-date form-input size-full --data-format-right"
      :class="{ '--has-error': hasError }"
    >
      <label v-if="showLabel" class="form-label" data-tool-tip="showInfoIcon">
        {{ title }}
        <info-icon v-if="showInfoIcon"></info-icon>
      </label>
      <input
        :name="name"
        v-model="value"
        v-on:focus="selectAll"
        v-on:change="setDate($event.target.value)"
      />
    </div>
    <span class="error-message date-input__error" v-if="hasError">{{
      error
    }}</span>
  </div>
</template>
<style lang="scss">
@import './../../../../sass/brcom/settings/_settings.theme-colors.scss';
.date-input__error {
  color: $theme-red-dark;
  font-family: 'Calibre-Regular', Arial, sans-serif;
}
</style>
<script>
import moment from 'moment'
import infoIcon from 'apps/legacy-components/rt-info.vue'
import calculatorEventBus from 'apps/bankrate-calculators/events'

export default {
  components: { infoIcon },
  props: {
    name: {
      type: String,
      required: true
    },
    trackingName: {
      type: String,
      default: ''
    },
    title: {
      type: String
    },
    format: {
      type: String,
      default: 'MM/DD/YYYY'
    },
    min: {
      type: Object,
      default: () => {
        return moment()
      }
    },
    copy: {
      type: Array,
      default: () => {
        return []
      }
    },
    error: {
      type: String
    },
    showInfoIcon: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    callback: {
      type: String,
      default: 'setDateValue'
    },
    allowPastDate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      hasError: false
    }
  },
  computed: {
    value() {
      const date = moment(this.$store.state[this.name])
      return date.isValid()
        ? date.format(this.format)
        : this.$store.state[this.name]
    },
    fieldName() {
      return this.trackingName ? this.trackingName : this.title.toLowerCase()
    }
  },
  methods: {
    setDate: function(date) {
      const inputtedDate = moment(date, this.format)
      const isValid = inputtedDate.isValid()
      const isPast = inputtedDate.isBefore(this.min, 'day')
      this.hasError = !isValid || (!this.allowPastDate && isPast)
      this.$store.dispatch(this.callback, {
        name: this.name,
        value: isValid ? inputtedDate : date,
        error: this.hasError
      })

      if (!this.hasError) {
        calculatorEventBus.$emit('fieldChanged', {
          fieldName: this.fieldName,
          value: inputtedDate.format(this.format)
        })
      }
    },
    selectAll: function(event) {
      // Workaround for Safari bug @todo - check if we still need this for new safari versions
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      setTimeout(function() {
        event.target.select()
      }, 0)
    }
  }
}
</script>
